module.exports = {
      id: "comm-news-usage",
      viewBox: "0 0 223.506 38.837",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#comm-news",
      toString: function () {
        return this.url;
      }
    }